import {React} from 'react';

const PreviousAppointments=(props)=>
{
  // Renders the appointments it is given. It used to copy props into state
  // after a one-second timeout, so anything that arrived later never appeared —
  // and the copy sat next to a block of mock "John Doe" appointments.
  const data = props.data;


  return (
    <div>
        {data && data.length> 0 && data.map((item) => (
          <div className='previous-appointment' key={item.apptId}> 
           <div>
           {/* Same fix as Doctor-HomePage: the old split(' ')[4] threw whenever the
               timestamp was not exactly "EEE MMM dd yyyy HH:mm:ss GMT+ZZZZ (zzz)",
               and showed the server's UTC time next to a locally-converted date. */}
           <h3 style={{display: 'inline-block'}}>{new Date(item.apptStartTime).toLocaleDateString()}, {new Date(item.apptStartTime).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</h3>{item.status == 'CANCELED' && <div className='cancel-tag'>cancelled</div>}
            <h3 >{item.patientName}</h3>
           </div>
             <ul>
             {/* <li>Diagnosisname: {item.diagnosisname}</li> */}
             <li style={ {textDecoration:'underline',color:'var(--youro-sky)'}}>view careplan and note provided</li>
             {/* <li>Symptom score: {item.symptomscore}</li> */}
              {/* <p>{item.meetup}</p> */}
             </ul>
          </div> 
        ))}
    </div>
  ); 
}

export default PreviousAppointments;